/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pre-op-check-list.reducer';

export const PreOpCheckListDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const preOpCheckListEntity = useAppSelector(state => state.preOpCheckList.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="preOpCheckListDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.preOpCheckList.detail.title">PreOpCheckList</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.id">Id</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.id}</dd>
          <dt>
            <span id="preparation">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.preparation">Preparation</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.preparation ? 'true' : 'false'}</dd>
          <dt>
            <span id="vitals">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.vitals">Vitals</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.vitals ? 'true' : 'false'}</dd>
          <dt>
            <span id="amCareSponge">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.amCareSponge">Am Care Sponge</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.amCareSponge ? 'true' : 'false'}</dd>
          <dt>
            <span id="amCareShower">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.amCareShower">Am Care Shower</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.amCareShower ? 'true' : 'false'}</dd>
          <dt>
            <span id="urinaryTime">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.urinaryTime">Urinary Time</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.urinaryTime}</dd>
          <dt>
            <span id="urinaryCatheter">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.urinaryCatheter">Urinary Catheter</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.urinaryCatheter ? 'true' : 'false'}</dd>
          <dt>
            <span id="enemaBowlWash">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.enemaBowlWash">Enema Bowl Wash</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.enemaBowlWash ? 'true' : 'false'}</dd>
          <dt>
            <span id="enemaLaxatives">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.enemaLaxatives">Enema Laxatives</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.enemaLaxatives ? 'true' : 'false'}</dd>
          <dt>
            <span id="preOpMedsGiven">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.preOpMedsGiven">Pre Op Meds Given</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.preOpMedsGiven ? 'true' : 'false'}</dd>
          <dt>
            <span id="preOpMedsGivenTime">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.preOpMedsGivenTime">Pre Op Meds Given Time</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.preOpMedsGivenTime}</dd>
          <dt>
            <span id="skinPreparation">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.skinPreparation">Skin Preparation</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.skinPreparation ? 'true' : 'false'}</dd>
          <dt>
            <span id="nbm">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.nbm">Nbm</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.nbm ? 'true' : 'false'}</dd>
          <dt>
            <span id="consent">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.consent">Consent</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.consent ? 'true' : 'false'}</dd>
          <dt>
            <span id="makingOfSite">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.makingOfSite">Making Of Site</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.makingOfSite ? 'true' : 'false'}</dd>
          <dt>
            <span id="medicationProfile">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.medicationProfile">Medication Profile</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.medicationProfile ? 'true' : 'false'}</dd>
          <dt>
            <span id="denturesRemoved">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.denturesRemoved">Dentures Removed</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.denturesRemoved ? 'true' : 'false'}</dd>
          <dt>
            <span id="lensesRemoved">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.lensesRemoved">Lenses Removed</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.lensesRemoved ? 'true' : 'false'}</dd>
          <dt>
            <span id="prostesisRemoved">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.prostesisRemoved">Prostesis Removed</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.prostesisRemoved ? 'true' : 'false'}</dd>
          <dt>
            <span id="prostesisNames">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.prostesisNames">Prostesis Names</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.prostesisNames}</dd>
          <dt>
            <span id="jewelleryRemoved">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.jewelleryRemoved">Jewellery Removed</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.jewelleryRemoved ? 'true' : 'false'}</dd>
          <dt>
            <span id="highRiskConsent">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.highRiskConsent">High Risk Consent</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.highRiskConsent ? 'true' : 'false'}</dd>
          <dt>
            <span id="bloodType">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.bloodType">Blood Type</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.bloodType ? 'true' : 'false'}</dd>
          <dt>
            <span id="bloodScreen">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.bloodScreen">Blood Screen</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.bloodScreen ? 'true' : 'false'}</dd>
          <dt>
            <span id="bloodHoldReady">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.bloodHoldReady">Blood Hold Ready</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.bloodHoldReady ? 'true' : 'false'}</dd>
          <dt>
            <span id="pacDone">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.pacDone">Pac Done</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.pacDone ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.active">Active</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{preOpCheckListEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpCheckList.surgery">Surgery</Translate>
          </dt>
          <dd>{preOpCheckListEntity.surgery ? preOpCheckListEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpCheckList.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{preOpCheckListEntity.anaesthesiologist ? preOpCheckListEntity.anaesthesiologist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpCheckList.nurse">Nurse</Translate>
          </dt>
          <dd>{preOpCheckListEntity.nurse ? preOpCheckListEntity.nurse.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pre-op-check-list" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pre-op-check-list/${preOpCheckListEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PreOpCheckListDetail;
